<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <Card>
                    <div class="row">
                        <h5 class="col-sm-12 col-md-10 text-bold">{{ __('Documents') }}</h5>

                        <div class="col-sm-12 col-md-2 right">
                            <button
                                @click="filterDocuments"
                                class="btn btn-sm btn-red w-100"
                                type="button"
                            >
                                {{ __('Filter') }}
                            </button>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    {{ __('Number') }}
                                </div>

                                <div class="col-sm-12 col-md-7">
                                    <FormInput
                                        name="document_no"
                                        type="text"
                                        v-model="document.documentNo"
                                    ></FormInput>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    {{ __('Date from') }}
                                </div>

                                <div class="col-sm-12 col-md-7">
                                    <DateTimePicker
                                        :placeholder="__('Select date from')"
                                        @change="formatDateFrom"
                                        format="YYYY-MM-DD"
                                        name="invoicedatefrom"
                                        type="date"
                                        v-model="document.dateFrom"
                                        value-type="formats"
                                    />
                                </div>

                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    {{ __('Date to') }}
                                </div>

                                <div class="col-sm-12 col-md-7">
                                    <DateTimePicker
                                        :placeholder="__('Select date to')"
                                        @change="formatDateTo"
                                        format="YYYY-MM-DD"
                                        name="invoicedateto"
                                        type="date"
                                        v-model="document.dateTo"
                                        value-type="format"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    {{ __('Status') }}
                                </div>

                                <div class="col-sm-12 col-md-7">
                                    <Autocomplete
                                        :fetch-callback="$api.autocomplete.attachmentDocumentsStates"
                                        :placeholder="__('Select status')"
                                        @selected="(item) => document.state = item.value"
                                        @input="(item) => document.state = item.value"
                                        params="title"
                                        value-selector="label"
                                    >
                                        <div slot-scope="result">
                                            {{ result.result.label }}
                                        </div>
                                    </Autocomplete>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">

                                </div>

                                <div class="col-sm-12 col-md-7">

                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-10">&nbsp;</div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-12 card-nopadding">
                            <wi-table
                                :default-params="{ sort: 'createdAt', order: 'desc'}"
                                :disable-pagination="true"
                                :disable-search="true"
                                :disableHeader="true"
                                :fetch-callback="fetch"
                                ref="documentTable"

                            >
                                <wi-table-column field="id" sortable>#</wi-table-column>
                                <wi-table-column field="title">{{ __('Title') }}</wi-table-column>
                                <wi-table-column :render="dateFormat" field="date">{{ __('Date') }}</wi-table-column>
                                <wi-table-column field="state.label">{{ __('Status') }}</wi-table-column>
                                <template slot="actions" slot-scope="{ item }">
                                    <button
                                        @click="documentOpen(item)"
                                        class="btn btn-outline-secondary btn-sm mr-1"
                                    >
                                        {{ __('Preview') }}
                                    </button>

                                    <button
                                        :disabled="item.state.value === 1"
                                        @click="documentApprove(item)"
                                        class="btn btn-outline-secondary btn-sm"
                                    >
                                        {{ __('Approve') }}
                                    </button>
                                </template>
                            </wi-table>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { __ } from '../../translations/localization'

export default {
  name: 'Documents',

  data () {
    return {
      document: {
        documentNo: null,
        dateFrom: null,
        dateTo: null,
        type: null,
        state: null
      }
    }
  },

  methods: {
    formatDateFrom (date) {
      this.document.dateFrom = moment(date).format('YYYY-MM-DD')
      return this.document.dateFrom
    },

    formatDateTo (date) {
      this.document.dateTo = moment(date).format('YYYY-MM-DD')
      return this.document.dateTo
    },

    dateFormat (item) {
      return moment(item.date).format('YYYY-MM-DD')
    },

    documentApprove (item) {
      this.$modal.confirm(
        __('Are you sure want to confirm this document?'),
        () => {
          return this.$api.documents.approve(item.id).then(() => {
            this.$toaster.success(__('Document successfully approved'))
            this.$refs.documentTable.updateTable()
          })
        })
    },

    documentOpen (item) {
      window.open(`${item.path}`, '_blank')
    },

    filterDocuments () {
      return this.$api.documents.list(this.document)
    },

    fetch (params = []) {
      return this.$api.documents.list(params)
    }
  }
}
</script>
